import { QUERY_KEY_PREFIXES } from 'dpl/shared/fetching/utils/constants';

export function buyerApplications(buyerProfileId, params = {}) {
  return {
    url: `/api/buyer_profiles/${buyerProfileId}/buyer_applications.json`,
    auto: Boolean(buyerProfileId),
    params,
    defaultValue: {
      data: [],
      meta: {}
    }
  };
}

export function buyerPayments(buyerProfileId) {
  return {
    url: `/api/buyer_profiles/${buyerProfileId}/payment_requests.json`,
    auto: Boolean(buyerProfileId),
    defaultValue: {
      data: [],
      meta: {}
    }
  };
}

export function buyerPaymentsV2QueryDefinition({ id, limit, status }) {
  return {
    params: { limit, status },
    url: `/api/buyer_profiles/${id}/payment_requests/v2.json`
  };
}

export function buyerProfile(buyerProfileId) {
  const base = `/api/buyer_profiles/${buyerProfileId}`;

  return {
    url: `${base}/edit.json`,
    defaultValue: {
      buyer_profile: {
        user_attributes: {
          profile_photo_attributes: {}
        }
      }
    },
    actions: {
      update: attributes => ({
        url: `${base}.json`,
        method: 'PUT',
        updateStrategy: 'success',
        body: {
          buyer_profile: attributes
        }
      })
    }
  };
}

export function buyerPaymentMethodQueryDefinition() {
  return {
    createFetchDataConfig: {
      ignoreRescueOn: [404]
    },
    url: `/api/stripe_payment_method.json`
  };
}

export function deleteBuyerPaymentMethodMutationDefinition() {
  return {
    method: 'DELETE',
    url: `/api/stripe_payment_method.json`
  };
}

export function chargeSavedPaymentMethodV2Mutation(paymentRequestId) {
  return {
    method: 'POST',
    url: `/api/payment_requests/${paymentRequestId}/charge_saved_payment_method/v2`
  };
}

export function buyerFavoriteBreederProfilesQueryDefinition(
  buyerProfileId,
  params
) {
  return {
    prefix: QUERY_KEY_PREFIXES.BUYER_FAVORITE_BREEDERS,
    url: `/api/buyer_profiles/${buyerProfileId}/followables/breeder_profiles.json`,
    params,
    defaultValue: {
      data: [],
      meta: {}
    }
  };
}

export function buyerFavoritePuppiesQueryDefinition(buyerProfileId, params) {
  return {
    prefix: QUERY_KEY_PREFIXES.BUYER_FAVORITE_PUPPIES,
    url: `/api/buyer_profiles/${buyerProfileId}/followables/puppies.json`,
    params,
    defaultValue: {
      data: [],
      meta: { total_item_count: 0, page: 1 }
    }
  };
}

export function buyerFavoriteBreedsQueryDefinition(buyerProfileId, params) {
  return {
    prefix:
      params.type === 'dogs'
        ? QUERY_KEY_PREFIXES.BUYER_FAVORITE_PUPPY_BREEDS
        : QUERY_KEY_PREFIXES.BUYER_FAVORITE_BREEDER_BREEDS,
    url: `/api/buyer_profiles/${buyerProfileId}/followables/breeds.json`,
    params,
    defaultValue: {
      data: [],
      meta: {}
    }
  };
}

export function buyerFavoritesSummariesQueryDefinition(buyerProfileId) {
  return {
    prefix: QUERY_KEY_PREFIXES.BUYER_FAVORITES_SUMMARIES,
    url: `/api/buyer_profiles/${buyerProfileId}/followables/summaries.json`,
    defaultValue: {
      data: { thumbnails: { breeders: [], puppies: [] } },
      meta: { total_puppies_count: 0, total_breeders_count: 0 }
    }
  };
}

export function buyerUserInterestsQueryDefinition() {
  return {
    url: `/api/buyer_interests.json`,
    defaultValue: {
      data: [],
      meta: {}
    }
  };
}
